import { create } from 'zustand';
import { persist } from 'zustand/middleware';

import { OrderItem, ShippingAddress } from '../models/OrderModel';
import { round2 } from '../utils';

type Cart = {
  items: OrderItem[];
  itemsPrice: number;
  // taxPrice: number;
  shippingPrice: number;
  totalPrice: number;

  paymentMethod: string;
  shippingAddress: ShippingAddress;
};

const initialState: Cart = {
  items: [],
  itemsPrice: 0,
  // taxPrice: 0,
  shippingPrice: 0,
  totalPrice: 0,
  paymentMethod: 'Email Discussion',
  shippingAddress: {
    fullName: '',
    email: '',
    city: '',
    postalCode: '',
    country: '',
  },
};

export const cartStore = create<Cart>()(
  persist(() => initialState, {
    name: 'cartStore',
  }),
);

const useCartService = () => {
  const {
    items,
    itemsPrice,
    // taxPrice,
    shippingPrice,
    totalPrice,
    paymentMethod,
    shippingAddress,
  } = cartStore();

  return {
    items,
    itemsPrice,
    // taxPrice,
    shippingPrice,
    totalPrice,
    paymentMethod,
    shippingAddress,
    increase: (item: OrderItem) => {
      const exist = items.find((x) => x.slug === item.slug);

      const updatedCartItems = exist
        ? items.map((x) =>
            x.slug === item.slug ? { ...exist, qty: exist.qty + 1 } : x,
          )
        : [...items, { ...item, qty: 1 }];

      // const { itemsPrice, shippingPrice, taxPrice, totalPrice } =
      const { itemsPrice, shippingPrice, totalPrice } =
        calcPrice(updatedCartItems);
      cartStore.setState({
        items: updatedCartItems,
        itemsPrice,
        shippingPrice,
        // taxPrice,
        totalPrice,
      });
    },
    decrease: (item: OrderItem) => {
      const exist = items.find((x) => x.slug === item.slug);
      if (!exist) return;

      const updatedCartItems =
        exist.qty === 1
          ? items.filter((x) => x.slug !== item.slug)
          : items.map((x) =>
              x.slug === item.slug ? { ...exist, qty: exist.qty - 1 } : x,
            );

      // const { itemsPrice, shippingPrice, taxPrice, totalPrice } =
      const { itemsPrice, shippingPrice, totalPrice } =
        calcPrice(updatedCartItems);
      cartStore.setState({
        items: updatedCartItems,
        itemsPrice,
        shippingPrice,
        // taxPrice,
        totalPrice,
      });
    },
    removeItem: (item: OrderItem) => {
      const updatedCartItems = items.filter((x) => x.slug !== item.slug);

      // const { itemsPrice, shippingPrice, taxPrice, totalPrice } =
      const { itemsPrice, shippingPrice, totalPrice } =
        calcPrice(updatedCartItems);
      cartStore.setState({
        items: updatedCartItems,
        itemsPrice,
        shippingPrice,
        // taxPrice,
        totalPrice,
      });
    },
    saveShippingAddress: (shippingAddress: ShippingAddress) => {
      cartStore.setState({
        shippingAddress,
      });
    },
    savePaymentMethod: (paymentMethod: string) => {
      cartStore.setState({
        paymentMethod,
      });
    },
    clear: () => {
      cartStore.setState({
        items: [],
      });
    },
    init: () => cartStore.setState(initialState),
  };
};


export default useCartService;

export const calcPrice = (items: OrderItem[]) => {
  const itemsPrice = round2(
      items.reduce((acc, item) => acc + Number(item.price) * Number(item.qty), 0),
    ),
    // shippingPrice = round2(itemsPrice > 100 ? 0 : 100),
    shippingPrice = 0,
    // taxPrice = round2(Number(0.15 * itemsPrice)),
    // totalPrice = round2(itemsPrice + shippingPrice + taxPrice);
    totalPrice = round2(itemsPrice + shippingPrice);
  return { itemsPrice, shippingPrice, totalPrice };
};
